import { Link } from 'react-router-dom'
import type { Artwork } from '../api'

type Props = { artwork: Artwork }

export function ArtworkCard({ artwork }: Props) {
  return (
    <Link to={`/artwork/${artwork.id}`} className="artwork-card">
      <div className="artwork-card-img">
        <img src={artwork.imageUrl} alt={artwork.title} loading="lazy" />
        {artwork.status === 'sold' && (
          <div className="artwork-sold-overlay"><span>Solgt</span></div>
        )}
      </div>
      <div className="artwork-card-body">
        <p className="artwork-card-title">{artwork.title}</p>
        <p className="artwork-card-artist">
          {/* stop propagation so clicking artist name doesn't follow the card link */}
          <Link to={`/artist/${artwork.artistSlug}`} onClick={e => e.stopPropagation()}>
            {artwork.artistName}
          </Link>
        </p>
        <div className="artwork-card-footer">
          <span className="artwork-card-price">
            {artwork.priceNok.toLocaleString('nb-NO')} NOK
          </span>
          <span className="artwork-card-medium">{artwork.medium}</span>
        </div>
      </div>
    </Link>
  )
}
